// BEAM design tokens — typography. v1 "Blueprint".
// Fonts are loaded via @expo-google-fonts at the app root before first render
// (see WO-M0 §Tasks). lineHeight values are absolute px, per React Native.
import type { TextStyle } from 'react-native';

// Family names match @expo-google-fonts exports. With custom fonts loaded,
// set fontFamily (NOT fontWeight) to select a weight.
export const fontFamily = {
  display:       'SpaceGrotesk_700Bold',
  displayMedium: 'SpaceGrotesk_600SemiBold',
  body:          'Inter_400Regular',
  bodyMedium:    'Inter_500Medium',
  bodySemibold:  'Inter_600SemiBold',
  bodyBold:      'Inter_700Bold',
  mono:          'JetBrainsMono_500Medium',
  monoSemibold:  'JetBrainsMono_600SemiBold',
} as const;

// Named text styles. Use these via a <Text variant> wrapper or by spreading
// `type.title` etc. into a StyleSheet. Don't set raw fontSize in screens.
export const type = {
  display:    { fontFamily: fontFamily.display,       fontSize: 32, lineHeight: 36, letterSpacing: -0.3 },
  title:      { fontFamily: fontFamily.display,       fontSize: 22, lineHeight: 26, letterSpacing: -0.2 },
  subhead:    { fontFamily: fontFamily.displayMedium, fontSize: 17, lineHeight: 22, letterSpacing: -0.1 },
  body:       { fontFamily: fontFamily.body,          fontSize: 15, lineHeight: 23 },
  bodyStrong: { fontFamily: fontFamily.bodySemibold,  fontSize: 15, lineHeight: 23 },
  small:      { fontFamily: fontFamily.bodyMedium,    fontSize: 13, lineHeight: 18 },
  // mono eyebrow / section label — uppercase, tracked
  label:      { fontFamily: fontFamily.monoSemibold,  fontSize: 11, lineHeight: 12, letterSpacing: 1.6, textTransform: 'uppercase' },
  // mono data — money, IDs, dates, phase counters
  data:       { fontFamily: fontFamily.mono,          fontSize: 15, lineHeight: 20 },
  // lineHeight must exceed fontSize or the tall mono glyph tops clip (esp. on Android).
  amount:     { fontFamily: fontFamily.monoSemibold,  fontSize: 24, lineHeight: 32, letterSpacing: -0.3 },
} satisfies Record<string, TextStyle>;

export type TypeVariant = keyof typeof type;
